import { ArrowUpRight, Facebook, Instagram, Youtube } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LocalizedLink } from "@/components/LocalizedLink";
import { FACEBOOK_URL, INSTAGRAM_URL, YOUTUBE_URL } from "@/lib/brand";
import logo from "@/assets/brand/fluxabee-logo-light.svg";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="field-footer">
      <div className="field-wrap">
        <div className="field-footer-top">
          <div>
            <LocalizedLink to="/" className="field-brand" aria-label="Fluxabee">
              <img src={logo} alt="" width={184} height={50} />
            </LocalizedLink>
            <p className="field-footer-description">
              {t("field.footer.tagline")}
            </p>
            <div className="field-footer-socials">
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
                <Instagram size={14} aria-hidden="true" />
                Instagram
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
                <Facebook size={14} aria-hidden="true" />
                Facebook
              </a>
              <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer">
                <Youtube size={14} aria-hidden="true" />
                YouTube
              </a>
            </div>
          </div>
          <nav aria-label={t("field.footer.explore")}>
            <h3>{t("field.footer.explore")}</h3>
            <ul>
              {[
                { to: "/", key: "field.nav.platform" },
                { to: "/platform", key: "field.nav.app" },
                { to: "/products", key: "field.nav.shop" },
                { to: "/guides", key: "field.nav.guides" },
                { to: "/manual/scale", key: "footer.manualScale" },
              ].map(({ to, key }) => (
                <li key={to}>
                  <LocalizedLink to={to}>{t(key)}</LocalizedLink>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <h3>{t("field.footer.help")}</h3>
            <div className="field-footer-contact">
              <a href="mailto:info@fluxabee.com">info@fluxabee.com</a>
              <a href="tel:+48795446752">+48 795 446 752</a>
              <LocalizedLink to="/contact">
                {t("nav.contact")}{" "}
                <ArrowUpRight size={13} className="inline" aria-hidden="true" />
              </LocalizedLink>
              <LocalizedLink to="/faq">{t("platform.nav.faq")}</LocalizedLink>
            </div>
          </div>
        </div>
        <p className="field-footer-large">{t("field.footer.slogan")}</p>
        <div className="field-footer-bottom">
          <p>{t("field.footer.copyright")}</p>
          <nav className="field-footer-legal" aria-label={t("footer.legal")}>
            {[
              { to: "/terms", key: "footer.terms" },
              { to: "/service-terms", key: "service.terms.title" },
              { to: "/account/subscription/withdrawal", key: "service.withdraw.title" },
              { to: "/privacy", key: "footer.privacy" },
              { to: "/returns", key: "footer.returns" },
            ].map(({ to, key }) => (
              <LocalizedLink key={to} to={to}>
                {t(key)}
              </LocalizedLink>
            ))}
          </nav>
        </div>
        <p className="field-footer-company">
          Fluxabee sp. z o.o. · NIP PL7773454586 · KRS 0001196656 · REGON
          542822142
        </p>
      </div>
    </footer>
  );
};
